/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace whitespace */

import { Injectable  }           from '@angular/core';
import { HttpClient }           from '@angular/common/http';
import { HttpHeaders }           from '@angular/common/http';
import { Observable }            from "rxjs";

import { AuthenticationService } from './authentication.service';
import { User       }            from '@/models/user';


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class ServerSideService
 *
 * @brief miscellaneous helpers for working with the backend server
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2022
 *
 */
export class ServerSideService {

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {

  }

  /** fetch any headers we need to send along with our request */
  headers() : HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    return new HttpHeaders().set('Authorization', `Bearer ${user.token}`);
  }

  /** fetch the server side environment variables */
  environmentVariables(): null|Observable<any> {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    return this.http.get(`/backend/environment`, {
      headers
    });
  }


}
